module.exports = __webpack_public_path__ + "img/9788990220240.6a17ecd5.jpg";